module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_8011.a754d3eb.png";